import * as Yup from 'yup';
import { Ingredient } from '../types';

const createValidationSchema = (ingredients: Ingredient[]) => {
  const shape: { [key: string]: Yup.NumberSchema } = {};

  ingredients.forEach((ingredient) => {
    shape[ingredient.id] = Yup.number()
      .min(0.01, 'tracker.logMeal.ingredients.validationError.accetableValue')
      .max(5000, 'tracker.logMeal.ingredients.validationError.accetableValue')
      .required('tracker.logMeal.input.validationError.empty');
  });

  return Yup.object().shape(shape);
};

export default createValidationSchema;
